const NotFound = () => {
  return (
    <>
      <div className="flex flex-col gap-4 w-full h-full justify-center items-center">
        <p className="text-8xl">404</p>
        <p className="text-5xl">Page not found</p>
      </div>
    </>
  );
};

export default NotFound;
